import React from "react"
import _ from "lodash"

import ConfirmationModal from "components/modal/confirmation-modal"

type DeleteConfirmProps = {
  show: boolean
  close: Function
  confirm: Function
  message: string
  title?: string
  tertiary: boolean
  tertiaryText: string
  tertiaryFunc: Function
  multipleItems?: object[]
}

const DeleteConfirmation = (props: DeleteConfirmProps) => {
  return (
    <ConfirmationModal
      height={100}
      width={600}
      contentHeight={props.multipleItems?.length ? undefined : 50}
      show={props.show}
      toggleShow={props.close}
      title={(props.title || "Delete") + " Confirmation"}
      confirmText={props.title || "Delete"}
      message={""}
      confirmFunc={props.confirm}
      cancelFunc={props.close}
      tertiary={props.tertiary}
      tertiaryText={props.tertiaryText}
      tertiaryFunc={props.tertiaryFunc}
      confirmOnly={false}
      closeOnly={false}>
        {props.message}
        <div>&nbsp;</div>
        {_.map(props.multipleItems, (i) => <div key={_.get(i, "code")}>{_.get(i, "code")}</div>)}
    </ConfirmationModal>
  )
}

export default DeleteConfirmation
